<script setup lang="ts">
import { onMounted, onUnmounted, watch } from 'vue';
import { RouterView, useRoute, useRouter } from 'vue-router';
import '@fareharbor-com/beacon-vue/fonts/roboto';
import {
  fareharborLightTheme,
  useTheme,
} from '@fareharbor-com/beacon-vue/themes';
import { initFlowbite } from 'flowbite';
import { broadcastService, MessageType } from '@/common/broadcastService';
import DemoBanner from '@/components/DemoBanner.vue';
import MainFooter from '@/components/MainFooter.vue';
import MainHeader from '@/components/MainHeader.vue';
import BaseFlexbox from '@/components/ui/BaseFlexbox/BaseFlexbox.vue';

useTheme(fareharborLightTheme);

const route = useRoute();
const router = useRouter();

function handleBroadcast({ type }: { type: MessageType }) {
  if (type === MessageType.LOGIN) {
    window.location.reload();
  }
  if (type === MessageType.LOGOUT) {
    // use the router instead of window.href if you prefer:
    router.replace({ name: 'login' });
  }
}

let unsubscribe: (() => void) | null = null;

onMounted(() => {
  initFlowbite();

  const updateSubscription = () => {
    // unsubscribe any previous
    unsubscribe?.();

    // check if the current route is the confirm-password-reset page
    if (route.name !== 'confirm-password-reset') {
      unsubscribe = broadcastService.subscribe(handleBroadcast);
    } else {
      unsubscribe = null;
    }
  };

  updateSubscription();
  watch(() => route.name, updateSubscription);
});

onUnmounted(() => {
  unsubscribe?.();
});
</script>

<template>
  <BaseFlexbox
    direction="column"
    gap="0"
    justifyContent="space-between"
    alignItems="stretch"
    class="min-h-screen"
  >
    <div class="flex flex-col flex-grow">
      <DemoBanner />
      <MainHeader />
      <RouterView :key="$route.fullPath" class="flex-grow" />
    </div>
    <MainFooter />
  </BaseFlexbox>
</template>
